import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CTASection = () => {
  const navigate = useNavigate();

  return (
    <section className="py-20 lg:py-24 bg-gradient-to-br from-primary via-primary/90 to-secondary relative overflow-hidden">
      <div className="absolute inset-0 bg-grid-pattern opacity-10" />
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center space-x-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full mb-8">
            <Icon name="Rocket" size={16} color="white" />
            <span className="text-sm font-medium text-white">Limited Time Offer</span>
          </div>

          <h2 className="text-3xl lg:text-5xl font-heading font-bold text-white mb-6">
            Start Building Your Authority Today
          </h2>

          <p className="text-lg lg:text-xl text-white/90 mb-8 leading-relaxed">
            Join 2,500+ entrepreneurs who've transformed their expertise into published books. Your first book could be ready in weeks, not years.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <Button
              variant="default"
              size="lg"
              iconName="ArrowRight"
              iconPosition="right"
              onClick={() => navigate('/user-registration')}
              className="bg-white text-primary hover:bg-white/90"
            >
              Create Your Free Account
            </Button>

            <Button
              variant="outline"
              size="lg"
              iconName="LogIn"
              iconPosition="left"
              onClick={() => navigate('/user-login')}
              className="border-white text-white hover:bg-white/10"
            >
              Sign In
            </Button>
          </div>

          <div className="grid sm:grid-cols-3 gap-8 pt-8 border-t border-white/20">
            <div className="text-center">
              <div className="w-12 h-12 mx-auto mb-3 bg-white/10 backdrop-blur-sm rounded-lg flex items-center justify-center">
                <Icon name="Zap" size={24} color="white" />
              </div>
              <p className="text-white font-semibold mb-1">No Credit Card Required</p>
              <p className="text-sm text-white/80">Start exploring for free</p>
            </div>

            <div className="text-center">
              <div className="w-12 h-12 mx-auto mb-3 bg-white/10 backdrop-blur-sm rounded-lg flex items-center justify-center">
                <Icon name="Shield" size={24} color="white" />
              </div>
              <p className="text-white font-semibold mb-1">Cancel Anytime</p>
              <p className="text-sm text-white/80">No long-term commitment</p>
            </div>

            <div className="text-center">
              <div className="w-12 h-12 mx-auto mb-3 bg-white/10 backdrop-blur-sm rounded-lg flex items-center justify-center">
                <Icon name="HeadphonesIcon" size={24} color="white" />
              </div>
              <p className="text-white font-semibold mb-1">Expert Support</p>
              <p className="text-sm text-white/80">We're here to help</p>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute -top-24 -left-24 w-96 h-96 bg-white/10 rounded-full blur-3xl" />
      <div className="absolute -bottom-24 -right-24 w-96 h-96 bg-white/10 rounded-full blur-3xl" />
    </section>
  );
};

export default CTASection;